import React, { useEffect, useRef, useState } from 'react';
import { Table } from '../../components/Table/Table';
import { edit_icon, search_icon } from '../../assets/imgs';
import { Location_list } from '../../screens/redux/api/dummyJson';
import { useAreaEditMutation, useDropDownLocationListMutation, useLazyAreaListQuery, useLazyAreaListViewQuery, useLazyLocationListQuery, useLocationListMutation, useLocationsEditMutation } from '../../screens/redux/api/api';
import { useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Area = ({ list, setPageno, pagecount, setPagecount, countryList, locationsApi }) => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const [name, setName] = useState();
    const [loader, setLoader] = useState(false);
    const [parentId, setParentId] = useState();
    const [id, setId] = useState();
    const [country, setCountry] = useState();
    const [state, setState] = useState();
    const [city, setCity] = useState();
    const [stateList, setStateList] = useState([]);
    const [cityList, setcityList] = useState([]);

    const [areaViewApi] = useLazyAreaListViewQuery();
    const [areaEditApi] = useLocationsEditMutation();
    const [dropDownLocationList] = useDropDownLocationListMutation();
    console.log('country_id', id)

    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const areaListView = (id) => {
        areaViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.data) {
                    setPopup(true);
                    // setType("edit");
                    setName(res?.data?.area?.name);
                    locationLists(2, res?.data?.country?.id)
                    locationLists(3, res?.data?.state?.id)
                    setCountry({ value: res?.data?.country?.id, label: res?.data?.country?.name })
                    setState({ value: res?.data?.state?.id, label: res?.data?.state?.name })
                    setCity({ value: res?.data?.city?.id, label: res?.data?.city?.name })
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const areaEdit = () => {
        const formdata = new FormData();
        formdata.append("type", 4);
        formdata.append("name", name);
        formdata.append("country_id", country?.value);
        formdata.append("state_id", state?.value);
        formdata.append("city_id", city?.value);
        formdata.append("id", id);
        setLoader(true);
        areaEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    setLoader(false);
                    setPopup(false);
                    toast.success(res?.message);
                    setName("");
                    locationsApi();
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }

    const locationLists = (type, id, search) => {
        const formdata = new FormData();
        formdata.append("type", type)
        if (type != 1) {
            formdata.append("parent_id", id)
        }
        if (search) {
            formdata.append('search', search)
        }
        dropDownLocationList(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let arr = res?.data?.map((item, ind) => {
                    let obj = {}
                    obj.value = item.id
                    obj.label = item.name
                    return obj;
                })
                if (type == 2) {
                    setStateList(arr)
                } else if (type == 3) {
                    setcityList(arr)
                }
                // setList(res?.data?.data);

            })
            .catch((err) => {
                console.log("err", err);
            })
    }



    useEffect(() => {
        if (id) {
            areaListView(id);
        }
    }, []);





    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Area",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            // {
            //     Header: "City",
            //     accessor: "city",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            // {
            //     Header: "Country",
            //     accessor: "country",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            // {
            //     Header: "State",
            //     accessor: "state",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            {
                Header: "Action",
                accessor: "property",
                Cell: ({ value, row }) => {
                    return <React.Fragment>
                        <div className="d-flex ac-jc">
                            {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                                <button
                                    onClick={() => { areaListView(row?.original?.id); setId(row?.original?.id); }}
                                    className="cust-btn "
                                >
                                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                </button>}

                        </div>
                    </React.Fragment >
                },
            },
        ],
        []
    );

    return (
        <div className="">
            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
            {popup && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new" >
                        <div className='d-flex ac-jb' >
                            <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                                Edit Area
                            </h4>
                            <button className='cust-btn' onClick={() => { setPopup(false); setName(""); setLoader(false) }}>
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Country
                        </h4>
                        <Select
                            className='input-pop_box'
                            options={countryList}
                            value={country}
                            onChange={(e) => { setCountry(e); locationLists(2, e.value) }}
                        />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            State
                        </h4>
                        <Select
                            className='input-pop_box'
                            options={stateList}
                            value={state}
                            onChange={(e) => { setState(e); locationLists(3, e.value) }}
                        />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            City
                        </h4>
                        <Select
                            className='input-pop_box'
                            options={cityList}
                            value={city}
                            onChange={(e) => { setCity(e); locationLists(4, e.value) }}
                        />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Area
                        </h4>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Area" />
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button onClick={() => { areaEdit() }} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3">
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )} Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};
export default Area